module.exports = __webpack_public_path__ + "static/media/chat_notify.104634cb.mp3";